<template>
  <div class="page coupon-detail">
    <navigation>{{ title }}</navigation>
    <div class="item">
      <div class="center">
        <span class="description">{{ getPacketDescription }}</span>
        <span class="title">
          邀请新用户-返现红包
        </span>
        <span class="wapper">
          <span class="amount">
            {{ getDiscountValue }}
          </span>

          <span class="unit">
            元
          </span>
        </span>
      </div>
    </div>

    <div class="content">
      <div class="row">
        <div class="left-title">
          红包类型
        </div>
        <div class="right-title">
          邀请新用户-返现红包
        </div>
      </div>

      <div class="row">
        <div class="left-title">
          红包有效期
        </div>
        <div class="right-title">
          {{ item.endTime | date('YYYY/MM/DD hh:mm:ss') }}
        </div>
      </div>
      <div class="row">
        <div class="left-title">
          面额
        </div>
        <div class="right-title">
          <span class="amount">
            {{ getDiscountValue }}
          </span>

          <span class="unit">
            元
          </span>
        </div>
      </div>
      <div class="row">
        <div class="left-title">
          用券说明
        </div>
        <div class="right-title">
        </div>
      </div>
      <div class="description" v-html="item.useDesc">
      </div>
    </div>

    <div class="footer">
      <nd-button class="btn" @click="goActivitiesBank" :disabled="['USING', 'USED', 'NOT'].includes(item.status) || ['NOT'].includes(item.checkResult)">
        {{ item.status | btnNames }}
      </nd-button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import TicketsMaps from './tickets-map'

export default {
  name: 'quan-detail',
  customReadyNotify: true,
  data () {
    return {
      couponRecordId: this.$route.query.couponRecordId || '',
      visiable: false,
      visiableAmount: false, // 配置的金额展示
      item: {},
      COUNT_DOWN: 5,
      time: 0, //
      timer: null,
      showInformation: false,
      checkPendding: false
    }
  },
  filters: {
    btnNames (status) {
      let str = ''
      switch (status) {
        case 'USING':
          str = '红包发放受理中'
          break
        case 'USED':
          str = '红包已使用'
          break
        default:
          str = '提现红包'
          break
      }
      return str
    }
  },
  async created () {
    await this.getCouponDetail()
    await this.getLimitX({ loanPlatform: 'TMD' })
    this.$bus.$emit('ready')
  },
  computed: {
    ...mapState('user', {
      loanStatus: (state) => state.quotaInfo.loanStatus
    }),
    getPacketDescription () {
      const { activeType, memberCouponDesc } = this.item
      return memberCouponDesc || TicketsMaps.PacketDescMap[activeType]
    },
    title () {
      return '红包详情'
    },
    getDiscountValue () {
      const { discountAmt, discountWay } = this.item
      if (discountAmt) {
        if (this.item.discountAmt <= 1 && discountWay === 'RATIO') {
          return (discountAmt * 10).toFixed(2).replace(/(?:\.0*|(\.\d+?)0+)$/, '$1')
        } else {
          return Number(discountAmt).toFixed(2)
        }
      } else {
        return '?'
      }
    },

    getButtonTitle () {
      const { couponType, status } = this.item
      return TicketsMaps.ButtonTitleMap[couponType] ||
        TicketsMaps.ButtonTitleMap['OTHER'](status) ||
        TicketsMaps.ButtonTitleMap['DEFAULT']
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
      clearInterval(this.timer)
    })
  },
  methods: {

    ...mapActions('user', ['getLimitX']),
    ...mapActions('activities', [
      'couponDetailX'
    ]),

    async getCouponDetail () {
      const res = await this.couponDetailX({
        couponRecordId: this.couponRecordId
      })
      if (res.success) {
        this.item = res.data || {}
      }
    },
    goActivitiesBank () {
      this.$router.push(
        `/activities/band?couponRecordId=${this.item.couponRecordId}&plan=${this.item.couponDetailType}`
      )
    }
  }
}
</script>

<style lang='less' src="./style.less"></style>
@import "../../assets/less/mixin.less";
